import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1130 - Capital Protection Certificate with Barrier
 *
 * At a glance: Rebate %, Autocall trigger %, Autocall Type, Autocall Frequency,
 *              Strike %, Capital protection %, Participation down %, Basket option type, Settlement type
 * Barrier: Upper barrier %, Lower barrier %
 * Underlying: Upper barrier %, Lower barrier %
 * Performance: Product price, Underlying con Upper barrier %, Lower barrier %
 */
export const config1130: ProductTypeConfig = {
  code: '1130',
  name: 'Capital Protection Certificate with Barrier',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        rebatePct: true,
        autocallTrigger: true,
        autocallType: true,
        autocallFrequency: true,
        strike: true,
        capitalProtectionPct: true,
        participationDownPct: true,
        basketOptionType: true,
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.barrier.props,
        upperBarrierPct: true,
        lowerBarrierPct: true,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false,
        barrierDistance: false,
        strikeLevel: false,
        strikeDistance: false,
        upperBarrierPct: true,
        lowerBarrierPct: true,
      },
    },

    coupons: {
      ...DEFAULT_SECTIONS.coupons,
      enabled: false,
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: false,
    },

    performance: {
      ...DEFAULT_SECTIONS.performance,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.performance.props,
        productPrice: true,
        upperBarrierPct: true,
        lowerBarrierPct: true,
      },
    },
  },
};
